import { render, staticRenderFns } from "./MessagesMenu.vue?vue&type=template&id=60e7385e&scoped=true&"
import script from "./MessagesMenu.vue?vue&type=script&lang=js&"
export * from "./MessagesMenu.vue?vue&type=script&lang=js&"
import style0 from "./MessagesMenu.vue?vue&type=style&index=0&id=60e7385e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7385e",
  null
  
)

export default component.exports